import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=1006e867&"
import script from "./Credit.vue?vue&type=script&lang=ts&"
export * from "./Credit.vue?vue&type=script&lang=ts&"
import style0 from "./Credit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports